var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"d-flex align-center justify-center overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"width":6,"color":"primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }